import { useContext } from 'react';
import { SearchSYNContext } from '../providers/SearchSYNProvider';

function useSearchSYN() {
    const { searchSYN, toggleSearchSYN } = useContext(SearchSYNContext);
    return { searchSYN, toggleSearchSYN };
}

export default useSearchSYN;